<template>
  <div
    :class="['boss-table-2-layout', { 'boss-table-2-layout-half': half }]"
    data-test="layout"
  >
    <div
      class="boss-table-2-item boss-table-2-item-head"
      data-test="label"
    >
      {{ label }}
      <div class="boss-color-red">
        ※スカウト件数調査ではこの検索条件は無効になります。
      </div>
    </div>
    <div
      :class="['boss-table-2-item', 'boss-table-2-item-body', { 'boss-table-2-item-body-has-child': hasChild }, { 'is-modified': isModified }]"
      data-test="body"
    >
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    half: {
      default: false,
      type: Boolean
    },
    hasChild: {
      default: false,
      type: Boolean
    },
    isModified: {
      default: false,
      type: Boolean
    },
    label: {
      default: '',
      type: String
    }
  }
}
</script>
